import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import {
  PrismButton,
  PrismIcon,
  PrismMessage,
  PrismModal,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { StepIndicator } from 'frontend-utils';
import type HotelBenchmarkInsightOnboardingController from 'lumen/controllers/hotel/benchmark-insight/onboarding';

interface HotelBenchmarkInsightOnboardingSignature {
  Args: {
    controller: HotelBenchmarkInsightOnboardingController;
    model: unknown;
  };
}

<template>
  {{! template-lint-disable require-presentational-children }}
  <PrismModal @onClose={{@controller.onCloseModal}}>
    <:headerContent>
      <h3
        class="flex w-full flex-col items-center justify-center gap-200 px-600 py-400"
      >
        {{t "benchmark_insight.onboarding.title"}}

        <StepIndicator
          @currentStep={{@controller.currentStepIndex}}
          @steps={{@controller.steps.length}}
        />
      </h3>
    </:headerContent>

    <:default>
      <div class="flex items-center justify-center">
        {{#if @controller.currentStepData}}
          <PrismMessage
            @description={{@controller.currentStepData.description}}
            @illustration={{@controller.currentStepData.illustration}}
          >
            <:link>
              <span
                class="prism-link prism-link--standalone text-200--medium flex flex-row gap-100"
                role="button"
                {{on "click" @controller.currentStepData.onClickLink}}
              >
                {{#if @controller.currentStepData.linkIcon}}
                  <PrismIcon @color="on-info" @name="book" @size="small" />
                {{/if}}

                {{@controller.currentStepData.linkText}}
              </span>
            </:link>
          </PrismMessage>
        {{/if}}
      </div>
    </:default>

    <:footer>
      <div
        class="flex flex-row
          {{if @controller.isFirstStep 'justify-end' 'justify-between'}}
          'items-center' px-500 py-300"
      >
        {{#unless @controller.isFirstStep}}
          <PrismButton
            @buttonType="secondary"
            @iconBefore="arrow-left"
            @label={{t "general.back"}}
            {{on "click" @controller.onClickBack}}
          />
        {{/unless}}

        {{#if @controller.isLastStep}}
          <PrismButton
            @label={{t "benchmark_insight.onboarding.get_started"}}
            {{on "click" @controller.onCloseModal}}
          />
        {{else}}
          <PrismButton
            @iconAfter="arrow-right"
            @label={{t "general.next"}}
            {{on "click" @controller.onClickNext}}
          />
        {{/if}}
      </div>
    </:footer>
  </PrismModal>
</template> satisfies TOC<HotelBenchmarkInsightOnboardingSignature>;
